import * as types from '../mutation-types'
import { get_all_customer, create_customer } from '@/api/customer'

export const getDefaultState = () => {
    return {
        selected_customer_name: 'Default',
        selected_customer_id: 0,
    }
}
export const state = {
    customers: [],
    selected_customer_name: 'Default',
    selected_customer_id: null,
    customer_status: false,
    loading: false,
    loading_create: false,
    customer: {}
}
export const getters = {
    customers: state => state.customers,
    customer: state => state.customer,
    loading: state => state.loading,
    loading_create: state => state.loading_create,
    selected_customer_name: state => state.selected_customer_name,
    selected_customer_id: state => state.selected_customer_id,
    customer_status: state => state.customer_status
}
export const mutations = {
    [types.FETCH_CUSTOMER](state, payload) {
        state.loading = true;
        state.customers = payload;
    },
    [types.FETCH_CUSTOMER_SUCCESS](state, payload) {
        state.loading = false;
        state.customers = payload;
    },
    [types.FETCH_CUSTOMER_FAILED](state, payload) {
        state.loading = false;
        state.customers = [];
    },
    [types.FETCH_SELECTED_CUSTOMER_NAME](state, payload) {
        state.selected_customer_name = payload;
    },
    [types.FETCH_SELECTED_CUSTOMER_ID](state, payload) {
        state.selected_customer_id = payload
    },
    [types.FETCH_CUSTOMER_STATUS_SUCCESS](state, payload) {
        if (state.customer_status) {
            Object.assign(state, getDefaultState());
        }
    },
    [types.RESET_CUSTOMER_STATE](state, payload) {
        state.customer_status = payload;
        Object.assign(state, getDefaultState());
    },
    [types.CUSTOMER](state, payload) {
        state.loading_create = true;
    },
    [types.CUSTOMER_SUCCESS](state, payload) {
        state.loading_create = false;
        state.customer = payload
    },
    [types.CUSTOMER_FAIL](state, payload) {
        state.loading_create = false;
        state.customer = {}
    },



}
export const actions = {
    async fetch_all_customer({ commit }, payload) {
        commit(types.FETCH_CUSTOMER);
        try {
            const data = await get_all_customer(payload);
            commit(types.FETCH_CUSTOMER_SUCCESS, data.data)
        } catch (error) {
            const err = error.response;
            commit(types.FETCH_CUSTOMER_FAILED, err);
        }
    },
    async fetch_customer_by_filter({ commit }, payload) {
        commit(types.FETCH_CUSTOMER);
        try {
            const data = await get_all_customer(payload);
            commit(types.FETCH_CUSTOMER_SUCCESS, data.items);
        } catch (error) {
            const err = error.response;
            commit(types.FETCH_CUSTOMER_FAILED, err);
        }
    },
    async fetch_selected_customer_name({ commit }, payload) {
        commit(types.FETCH_CUSTOMER);
        try {
            commit(types.FETCH_SELECTED_CUSTOMER_NAME, payload.customer_name)
            commit(types.FETCH_SELECTED_CUSTOMER_ID, payload.customer_id)
        } catch (error) {
            const err = error.response;
            commit(types.FETCH_CUSTOMER_FAILED, err);
        }
    },
    async getCustomerStatus({ commit }, payload) {
        try {
            commit(types.FETCH_CUSTOMER_STATUS_SUCCESS, payload)
        } catch (error) {
            const err = error.response;
            commit(types.FETCH_CUSTOMER_STATUS_ERROR, err);
        }
    },
    async resetCustomerState({ commit }, payload) {
        commit(types.RESET_CUSTOMER_STATE, payload)
    },
    async create_customer({ commit }, payload) {
        try {
            commit(types.CUSTOMER);
            const response = await create_customer(payload);
            commit(types.CUSTOMER_SUCCESS, response.data);
        } catch (error) {
            commit(types.CUSTOMER_FAIL);
        }
    }
}